import { saveLegacyToken, saveOAuth2Token } from './saveToken'
import { isOAuth2AccessJwt } from './oauth2Tokens'

/**
 * Диплинк-вход в ЛК из консоли техподдержки.
 *
 * Консоль открывает вкладку с токенами в query:
 *   https://desktop.doki.online/profile?access_token=<...>&refresh_token=<...>
 *
 * Здесь мы при старте SPA (до чтения сессии из localStorage в App.tsx)
 * перекладываем токены из адресной строки в localStorage — в тот же формат,
 * что и после обычного логина, после чего вычищаем их из URL.
 *
 * Поддерживаются два сценария:
 *   1. Старый "вечный" токен (не JWT) — пишется в legacy-ключ access_token.
 *   2. Новая пара access/refresh (JWT) — access в памяти, refresh в LS (persistRefresh).
 *
 * @returns true, если токен был найден в query и сохранён.
 */
export function bootstrapAuthFromQuery(): boolean {
    try {
        const params = new URLSearchParams(window.location.search)
        const accessToken = params.get('access_token')
        const refreshToken = params.get('refresh_token')

        if (!accessToken) {
            return false
        }

        // Новая OAuth2-пара (JWT access) или явно переданный refresh — храним структуру token.
        // Старый "вечный" токен (не JWT) уходит в legacy-хранилище.
        if (refreshToken || isOAuth2AccessJwt(accessToken)) {
            saveOAuth2Token({
                access_token: accessToken,
                refresh_token: refreshToken || '',
            }, { persistRefresh: true })
        } else {
            saveLegacyToken(accessToken)
        }

        // Убираем токены из адресной строки (история, скриншоты, Referer, копирование ссылки).
        const url = new URL(window.location.href)
        url.searchParams.delete('access_token')
        url.searchParams.delete('refresh_token')
        window.history.replaceState({}, '', url.pathname + url.search + url.hash)

        return true
    } catch (error) {
        console.error('Failed to bootstrap auth from query params:', error)
        return false
    }
}
